import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { EyebrowText } from "@faire/retailer-visitor-shared/components/TestimonialsCardSection/common";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
var TestimonialCardBase = function(param) {
    var testimonial = param.testimonial, title = param.title, textColor = param.textColor, titleColor = param.titleColor, textStyle = param.textStyle;
    var isSSR = useIsSSR();
    var viewport = useViewport();
    var _useResponsiveValue = useResponsiveValue({
        mobileAndAbove: {
            width: 227,
            height: 295
        },
        desktopAndAbove: {
            width: 401,
            height: 521
        }
    }), width = _useResponsiveValue.width, height = _useResponsiveValue.height;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            /*#__PURE__*/ _jsxs(InfoWrapper, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            viewport.isTabletAndAbove ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(EyebrowText, {
                                        $color: titleColor ? titleColor : textColor,
                                        children: title
                                    }),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        height: viewport.isTablet ? "3x" : "5x"
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ _jsx(Typography, {
                                color: textColor,
                                variant: textStyle ? textStyle : {
                                    mobileAndAbove: "pageHeaderSerifRegular",
                                    desktopAndAbove: "displaySSerifRegular"
                                },
                                children: testimonial.text
                            })
                        ]
                    }),
                    viewport.isMobile ? /*#__PURE__*/ _jsx(Spacer, {
                        size: "3x"
                    }) : null,
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                color: textColor,
                                variant: {
                                    mobileAndAbove: "subheadingSansMedium",
                                    desktopAndAbove: "sectionHeaderSansMedium"
                                },
                                children: testimonial.name
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "1x"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                color: textColor,
                                variant: {
                                    mobileAndAbove: "paragraphSansRegular",
                                    desktopAndAbove: "subheadingSansRegular"
                                },
                                children: testimonial.info
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: {
                    mobileAndAbove: "3x",
                    tabletAndAbove: "4x",
                    desktopAndAbove: "9x",
                    xLargeAndAbove: "10x",
                    xxLargeDesktop: 115
                }
            }),
            /*#__PURE__*/ _jsx(Image, {
                src: optimizeImageUrl({
                    url: testimonial.imageUrl
                }, isSSR, {
                    width: width,
                    height: height,
                    resizeMethod: "fit"
                })
            })
        ]
    });
};
export var TestimonialCard = observer(TestimonialCardBase);
var Wrapper = styled(Flex).attrs({
    align: {
        mobileAndAbove: "center",
        tabletAndAbove: "stretch"
    },
    direction: {
        mobileAndAbove: "column-reverse",
        tabletAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-11eaae25-0"
})([
    "max-width:1310px;margin:0 auto;width:100%;",
    "{width:auto;}"
], responsiveMediaQueries.tabletAndAbove);
var InfoWrapper = styled(Column).attrs({
    justify: {
        mobileAndAbove: "normal",
        tabletAndAbove: "space-between"
    }
}).withConfig({
    componentId: "sc-11eaae25-1"
})([
    ""
]);
var Image = styled.img.withConfig({
    componentId: "sc-11eaae25-2"
})([
    "width:100%;",
    "{width:auto;height:295px;}",
    "{height:521px;}"
], responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktopAndAbove);
